import { SxProps, Theme } from '@mui/material/styles';
import { CSSProperties } from 'react';

const cardStyle: CSSProperties = {
  marginTop: '24px',
  marginBottom: '24px'
};

export const CitationReportStyles = {
  card: cardStyle,

  headerBox: {
    paddingX: { xs: '16px', md: '24px' }
  } as SxProps<Theme>,

  heading: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '18px', sm: '20px', md: '24px' },
    lineHeight: { xs: '24px', md: '32px' },
    color: 'var(--color-primary)'
  } as SxProps<Theme>,

  subHeading: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: { xs: '12px', md: '14px' },
    lineHeight: { xs: '18px', md: '20px' },
    color: 'var(--color-text-secondary)',
    marginTop: '12px'
  } as SxProps<Theme>,

  tableContainer: {
    marginTop: { xs: '16px', md: '24px' }
  } as SxProps<Theme>,

  actionsContainer: {
    paddingX: { xs: '16px', md: '24px' },
    marginTop: { xs: '16px', md: '24px' },
    display: 'flex',
    gap: '12px',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'stretch', sm: 'center' }
  } as SxProps<Theme>,

  // Table column styles
  citationSiteText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)'
  } as SxProps<Theme>,

  statusText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-success-dark)',
    textTransform: 'capitalize'
  } as SxProps<Theme>,

  businessNameText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-purple-strong)',
    marginBottom: '8px'
  } as SxProps<Theme>,

  businessAddressText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-text-near-black)'
  } as SxProps<Theme>,

  directoryVisitsText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-secondary)'
  } as SxProps<Theme>,

  visitChangePercentText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-success-dark)'
  } as SxProps<Theme>,

  trendIcon: {
    display: 'inline-block',
    marginX: '10px'
  } as SxProps<Theme>,

  removedDuplicatesText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-purple-strong)'
  } as SxProps<Theme>,

  // Button styles
  primaryButton: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    padding: '8px 18px',
    width: { xs: '100%', sm: 'auto' }
  } as SxProps<Theme>,

  secondaryButton: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    padding: '8px 18px',
    width: { xs: '100%', sm: 'auto' }
  } as SxProps<Theme>,

  lastButton: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    padding: '8px 18px',
    marginLeft: { xs: 0, sm: 'auto' },
    width: { xs: '100%', sm: 'auto' }
  } as SxProps<Theme>
};

